import React from 'react'
import './MyAccount.scss'
import { useLanguage } from '../Contexts/LanguageContext'

const MyAccount = () => {
  const { language } = useLanguage();

  return (
    <div className='my-account-page'>
        <h1>
            {language === 'polish' ? 'moje konto' : 'my account'}
        </h1>
        <br />
        <p>🛠️🔨⚙️ {language === 'polish' ? 'strona w budowie' : 'page under construction'} 🛠️🔨⚙️</p>
    </div>
  )
}

export default MyAccount